var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03757 6.32911C6.84262 6.13416 6.52557 6.13416 6.33063 6.32911C5.74579 6.91395 4.79269 6.91395 4.20778 6.32911L2.43945 4.56078C2.15589 4.27722 2.00032 3.9011 2.00032 3.49939C2.00032 3.09769 2.15588 2.72157 2.43945 2.43801C3.02429 1.85317 3.9754 1.85317 4.5623 2.43801L5.64929 3.525C5.84423 3.71994 6.16128 3.71994 6.35623 3.525C6.55117 3.33005 6.55117 3.013 6.35623 2.81805L5.26924 1.73106C4.29449 0.756312 2.70728 0.756312 1.73254 1.73106C1.25994 2.20367 1 2.82986 1 3.49939C1 4.16694 1.25994 4.79512 1.73254 5.26772L3.50087 7.03605C3.98923 7.52245 4.62922 7.76662 5.2692 7.76662C5.90919 7.76662 6.54918 7.52245 7.03753 7.03605C7.23248 6.84111 7.23248 6.52406 7.03753 6.32911H7.03757Z",
    fill: "#CBCBCD",
    stroke: "#CBCBCD",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2711 6.73279L8.50273 4.96446C7.52798 3.98971 5.94077 3.98971 4.96603 4.96446C4.77109 5.15941 4.77109 5.47646 4.96603 5.67141C5.16098 5.86635 5.47803 5.86635 5.67298 5.67141C6.25782 5.08657 7.20893 5.08657 7.79582 5.67141L9.56415 7.43973C9.84771 7.7233 10.0033 8.09942 10.0033 8.50112C10.0033 8.90283 9.84772 9.27895 9.56415 9.56251C8.99703 10.1296 8.0085 10.1296 7.44131 9.56251L6.35628 8.47552C6.16133 8.28057 5.84428 8.28057 5.64934 8.47552C5.45439 8.67047 5.45439 8.98752 5.64934 9.18246L6.73633 10.2675C7.20893 10.7401 7.83711 11 8.50466 11C9.17221 11 9.80038 10.7401 10.273 10.2675C10.7456 9.79488 11.0055 9.16671 11.0055 8.49916C11.0036 7.83161 10.7436 7.20541 10.271 6.73281L10.2711 6.73279Z",
    fill: "#CBCBCD",
    stroke: "#CBCBCD",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableLink);
export default __webpack_public_path__ + "static/media/disable_link.aac0357674659b056ade8a3fe66561bb.svg";
export { ForwardRef as ReactComponent };